import moment, { Moment } from 'moment';
import { Allocation, ResourceType } from 'api/resource-management/types';
import { getDateAfterSomeNumberOfWorkingDays } from 'components/organisms/timesheets/common/utils';
import { DefaultWorkingDayConfig } from 'components/organisms/user-capacity';
import { TemplateAllocation } from 'data/templates/projects';
import { defaultFormat } from 'utils/date-field/formatter';

export const asTemplateAllocation =
  (relativeDate: Moment, isHoursPerWeek?: boolean) =>
  (allocation: Allocation): TemplateAllocation => {
    let adjStartDate = allocation.startDate;
    let adjEndDate = allocation.endDate;

    if (isHoursPerWeek) {
      // Since we hide weekends in template scheduler,
      // this piece of code ensures that the allocation start dates
      // and durations are properly adjusted after being fetched from scheduler.
      const allocationStartDate = moment(allocation.startDate);
      const startDate = allocationStartDate.diff(relativeDate, 'days');
      const allocationEndDate = moment(allocation.endDate);
      const adjDuration =
        allocationEndDate.diff(allocationStartDate, 'days') + 1;
      const adjustedStartDate = getDateAfterSomeNumberOfWorkingDays(
        relativeDate,
        startDate,
        DefaultWorkingDayConfig,
      );
      const adjustedEndDate = getDateAfterSomeNumberOfWorkingDays(
        adjustedStartDate,
        adjDuration - 1,
        DefaultWorkingDayConfig,
      );

      adjStartDate = defaultFormat(adjustedStartDate);
      adjEndDate = defaultFormat(adjustedEndDate);
    }

    let startDay = 0;
    let duration = 0;

    startDay = moment(adjStartDate).diff(relativeDate, 'day');
    duration = moment(adjEndDate).diff(moment(adjStartDate), 'day') + 1;

    if (isHoursPerWeek) {
      const weekDiff = moment(allocation.startDate).diff(relativeDate, 'week');

      startDay = weekDiff * 5 + 1;
      duration =
        (moment(allocation.endDate).diff(moment(allocation.startDate), 'week') +
          1) *
        5;
    }

    return {
      id: allocation.id,
      minutes: allocation.minutes,
      projectPhaseId: allocation.projectPhaseId,
      billable: allocation.billable,
      startDay,
      duration,
      medium: allocation.medium,
      ...(allocation.type === ResourceType.User
        ? { type: ResourceType.User, userId: allocation.userId }
        : { type: ResourceType.Team, teamId: allocation.teamId }),
      sources: allocation.sources,
    };
  };
